module.exports = __webpack_public_path__ + "static/media/skip.fd4cf888.svg";